module.exports = __webpack_public_path__ + "img/settings.c511e83c.svg";